import React, { useEffect, useState } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Tabs } from '@uhg-abyss/web/ui/Tabs';
import { Header as AbyssHeader } from '@uhg-abyss/web/ui/Header';
import { useAuth } from '@src/Providers/AuthProvider';
import { Header } from '../Header';
import { useToast } from '@uhg-abyss/web/hooks/useToast';

export const AppBody = () => {
  const [availableTabs, setAvailableTabs] = useState({
    cdb: { visible: false, label: 'cdb' },
    prime: { visible: false, label: 'prime' },
    gps: { visible: false, label: 'gps' },
  });
  const { toast } = useToast();
  const router = useRouter();
  const { user } = useAuth();
  const { service } = router.getRouteParams();
  const [activeIndex, setActiveIndex] = useState(service === 'gps' ? 1 : 0);
  const { pathname } = router.getLocation();

  useEffect(() => {
    setAvailableTabs({
      cdb: {
        label:
          user?.userType === 'I'
            ? 'CES/CDB'
            : 'Electronic Eligibility System - Batch',
        visible: !!user?.cdbAccess && !user?.onlyPrimeAccess,
      },
      gps: {
        visible: !!user?.gpsAccess && !user?.onlyPrimeAccess,
        label: user?.userType === 'I' ? 'GPS' : 'Medicare & Retirement',
      },
      prime: {
        visible: !!user?.primeAccess,
        label: user?.userType === 'I' ? 'PRIME' : 'Small Business',
      },
    });
  }, [user]);

  useEffect(() => {
    const visibleTabs = Object.entries(availableTabs).reduce(
      (acc, [key, tab]) => {
        if (tab?.visible && key) acc.push(key);
        return acc;
      },
      [] as string[]
    );
    setActiveIndex(
      service === 'gps'
        ? visibleTabs?.indexOf('gps')
        : service === 'prime'
        ? visibleTabs.indexOf('prime')
        : visibleTabs.indexOf('cdb')
    );
  }, [availableTabs]);

  const isHome =
    pathname === '/' ||
    pathname === '/gps/' ||
    pathname === '/cdb/' ||
    pathname === '/gps' ||
    pathname === '/cdb';

  useEffect(() => {
    const visibleTabs = Object.entries(availableTabs).reduce(
      (acc, [key, tab]) => {
        if (tab?.visible && key) acc.push(key);
        return acc;
      },
      [] as string[]
    );
    setActiveIndex(
      service === 'gps'
        ? visibleTabs?.indexOf('gps')
        : visibleTabs?.indexOf('cdb')
    );
  }, [service, availableTabs]);

  const handleTabChange = async (index) => {
    setActiveIndex(index);
    const visibleTabs = Object.entries(availableTabs).reduce(
      (acc, [key, tab]) => {
        if (tab?.visible && key) acc.push(key);
        return acc;
      },
      [] as string[]
    );

    if (visibleTabs[index] === 'cdb') {
      router.navigate('cdb');
      return;
    }
    if (visibleTabs[index] === 'gps') {
      router.navigate('gps');
      return;
    }
    if (visibleTabs[index] === 'prime') {
      // PRIME redirect API (getPrimeRedirectUri) has been decommissioned - PRIME access
      // via this tab is no longer available.
      toast.show({
        id: 'prime-unavailable',
        withCloseButton: true,
        title: 'PRIME is unavailable',
        message: 'PRIME access is no longer available.',
        ariaLoadingLabel: 'PRIME is unavailable',
      });
      setActiveIndex(0);
      handleTabChange(0);
      return;
    }
  };

  return (
    <>
      <Header isHome={isHome} />
      {isHome &&
      user?.userStatus === 'A' &&
      (user?.cdbAccess || user?.gpsAccess || user?.primeAccess) ? (
        <AbyssHeader.Container
          css={{
            'abyss-header-root': {
              backgroundColor:
                'var(--abyss-colors-web-semantic-color-surface-container-secondary)',
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
              width: '100%',
              position: 'sticky',
              top: '0px',
              zIndex: 3000,
            },
            'abyss-header-container': {
              maxWidth: '1248px',
            },
          }}
        >
          <Tabs title="" active={activeIndex} onTabChange={handleTabChange}>
            {availableTabs?.cdb?.visible ? (
              <Tabs.Tab label={availableTabs?.cdb?.label} />
            ) : null}
            {availableTabs?.gps?.visible ? (
              <Tabs.Tab label={availableTabs?.gps?.label} />
            ) : null}
            {availableTabs?.prime?.visible ? (
              <Tabs.Tab label={availableTabs?.prime?.label} />
            ) : null}
          </Tabs>
        </AbyssHeader.Container>
      ) : null}
      <Router.Outlet />
    </>
  );
};
